module.exports = __webpack_public_path__ + "img/pexels.772c094c.png";